/* HS Reviews — storefront widgets fed by the Holy Shape PO app (product reviews, reviews wall, write-a-review modal). */
(function () {
  if (window.HSReviews) return;
  var APP = 'https://shopify-po-system-production.up.railway.app/hs-reviews';
  var LANG = (document.documentElement.lang || 'en').slice(0, 2) === 'ar' ? 'ar' : 'en';
  var T = LANG === 'ar' ? {
    based: function (n) { return 'بناءً على ' + n + ' تقييم'; }, none: 'لا توجد تقييمات بعد', first: 'كوني أول من يشارك تجربتها مع هذا المنتج.',
    noMatch: 'لا توجد تقييمات مطابقة لهذا الفلتر.', failed: 'تعذّر تحميل التقييمات حالياً.', verified: 'مشترية موثّقة', customer: 'عميلة', replied: 'ردّ Holy Shape',
    more: 'عرض المزيد', readMore: 'اقرئي المزيد', showing: function (a, b) { return a + ' من ' + b; }, photos: function (n) { return n + ' صورة'; },
    today: 'اليوم', days: function (n) { return 'منذ ' + n + ' يوم'; }, months: function (n) { return 'منذ ' + n + ' شهر'; }, years: function (n) { return 'منذ ' + n + ' سنة'; },
    wait: 'نجهّز نموذج التقييم، لحظات من فضلك…', close: 'إغلاق', prev: 'السابق', next: 'التالي', write: 'اكتبي تقييمك', on: 'عن', stars: function (n) { return n + ' من 5'; },
  } : {
    based: function (n) { return 'Based on ' + n + (n === 1 ? ' review' : ' reviews'); }, none: 'No reviews yet', first: 'Be the first to share how it fits.',
    noMatch: 'No reviews match this filter.', failed: 'Reviews could not be loaded right now.', verified: 'Verified buyer', customer: 'Customer', replied: 'Holy Shape replied',
    more: 'Show more reviews', readMore: 'Read more', showing: function (a, b) { return 'Showing ' + a + ' of ' + b; }, photos: function (n) { return n + (n === 1 ? ' photo' : ' photos'); },
    today: 'Today', days: function (n) { return n + (n === 1 ? ' day ago' : ' days ago'); }, months: function (n) { return n + (n === 1 ? ' month ago' : ' months ago'); }, years: function (n) { return n + (n === 1 ? ' year ago' : ' years ago'); },
    wait: 'Getting the review form ready. One moment…', close: 'Close', prev: 'Previous', next: 'Next', write: 'Write a review', on: 'on', stars: function (n) { return n + ' out of 5'; },
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function stars(n, cls) { return '<span class="hsr-stars' + (cls ? ' ' + cls : '') + '" style="--p:' + Math.max(0, Math.min(100, n / 5 * 100)) + '%" role="img" aria-label="' + T.stars(n) + '"></span>'; }
  function ago(iso) {
    var day = (Date.now() - new Date(iso)) / 86400000;
    if (day < 1) return T.today;
    if (day < 30) return T.days(Math.round(day));
    if (day < 365) return T.months(Math.round(day / 30));
    return T.years(Math.round(day / 365));
  }
  function initial(name) { return String(name || '').trim().charAt(0).toUpperCase() || '•'; }
  /* The PO app restarts for about a minute on every deploy: fall back to the last good answer kept in this browser, else keep trying quietly */
  function getJson(url, tries) {
    tries = tries == null ? 20 : tries;
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }).then(function (j) {
      try { localStorage.setItem('hsr:' + url, JSON.stringify(j)); } catch (e) {}
      return j;
    }, function (err) {
      try { var c = localStorage.getItem('hsr:' + url); if (c) return JSON.parse(c); } catch (e) {}
      if (tries <= 0) throw err;
      return new Promise(function (res) { setTimeout(res, 6000); }).then(function () { return getJson(url, tries - 1); });
    });
  }
  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }

  /* ── Write-a-review modal: the form itself is a page of the PO app, framed ── */
  var modal = null;
  function openWrite(o) {
    o = o || {};
    closeWrite();
    var q = ['embed=1', 'lang=' + LANG];
    if (o.product) q.push('product=' + encodeURIComponent(o.product));
    if (o.o) q.push('o=' + encodeURIComponent(o.o));
    if (o.k) q.push('k=' + encodeURIComponent(o.k));
    if (o.stars) q.push('stars=' + encodeURIComponent(o.stars));
    var me = window.hsCustomer;   // signed-in customer (snippets/hs-global.liquid): prefills name + email
    if (me && me.name) q.push('name=' + encodeURIComponent(me.name));
    if (me && me.email) q.push('email=' + encodeURIComponent(me.email));
    modal = el('<div class="hsr-modal" role="dialog" aria-modal="true" aria-label="' + T.write + '"><div class="hsr-modal-panel"><button type="button" class="hsr-x" aria-label="' + T.close + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div class="hsr-modal-load"></div><p class="hsr-modal-wait" role="status" hidden>' + T.wait + '</p><iframe title="' + T.write + '"></iframe></div></div>');
    modal._back = document.activeElement;
    document.body.appendChild(modal);
    document.documentElement.classList.add('hsr-lock');
    var frame = modal.querySelector('iframe'), me2 = modal, base = (o.api || APP).replace(/\/$/, '');
    frame.addEventListener('load', function () { if (frame.getAttribute('src')) { me2.classList.add('is-ready'); frame.focus(); } });
    // The form is only framed once the app answers, so a deploy never shows the host's error page
    (function ready() {
      if (modal !== me2) return;
      fetch(base + '/products/0', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('down'); frame.src = base + '/write?' + q.join('&'); })
        .catch(function () { me2.querySelector('.hsr-modal-wait').hidden = false; setTimeout(ready, 4000); });
    })();
    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('.hsr-x')) closeWrite(); });
    requestAnimationFrame(function () { modal && modal.classList.add('is-on'); });
  }
  function closeWrite() {
    if (!modal) return;
    var m = modal; modal = null;
    document.documentElement.classList.remove('hsr-lock');
    m.classList.remove('is-on');
    setTimeout(function () { m.remove(); }, 250);
    if (m._back && m._back.focus) m._back.focus();
  }
  window.addEventListener('message', function (e) {
    var d = e.data;
    if (!modal || !d || !d.hsr) return;
    if (d.hsr === 'close') closeWrite();
    if (d.hsr === 'height') modal.querySelector('iframe').style.height = Math.ceil(d.h) + 'px';
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeWrite(); closeLb(); } });

  /* ── Photo lightbox ── */
  var lb = null, lbList = [], lbi = 0;
  function openLb(list, i) {
    if (!list.length) return;
    lbList = list; lbi = (i + list.length) % list.length;
    if (!lb) {
      lb = el('<div class="hsr-lb" role="dialog" aria-modal="true"><button type="button" class="hsr-x" aria-label="' + T.close + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button><button type="button" class="hsr-lb-nav is-prev" aria-label="' + T.prev + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button><button type="button" class="hsr-lb-nav is-next" aria-label="' + T.next + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button><div class="hsr-lb-in"><div class="hsr-lb-media"></div><div class="hsr-lb-side"></div></div></div>');
      document.body.appendChild(lb);
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.closest('.hsr-x')) return closeLb();
        if (e.target.closest('.is-prev')) openLb(lbList, lbi - 1);
        if (e.target.closest('.is-next')) openLb(lbList, lbi + 1);
      });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-on')) return;
        if (e.key === 'ArrowLeft') openLb(lbList, lbi - 1);
        if (e.key === 'ArrowRight') openLb(lbList, lbi + 1);
      });
    }
    var x = lbList[lbi], m = x.m, r = x.r;
    lb.querySelector('.hsr-lb-media').innerHTML = m.type === 'video' ? '<video src="' + esc(m.url) + '" controls autoplay playsinline></video>' : '<img src="' + esc(m.url) + '" alt="">';
    lb.querySelector('.hsr-lb-side').innerHTML = stars(r.rating) + (r.heading ? '<h3 dir="auto">' + esc(r.heading) + '</h3>' : '') + (r.body ? '<p dir="auto">' + esc(r.body) + '</p>' : '') + who(r);
    lb.classList.toggle('is-single', lbList.length < 2);
    lb.classList.add('is-on');
    document.documentElement.classList.add('hsr-lock');
  }
  function closeLb() {
    if (!lb || !lb.classList.contains('is-on')) return;
    lb.classList.remove('is-on'); lb.querySelector('.hsr-lb-media').innerHTML = '';
    if (!modal) document.documentElement.classList.remove('hsr-lock');
  }

  /* Fixed labels of the sections are English in the theme files; Arabic visitors get them here */
  var UI = { 'All': 'الكل', 'With photos': 'مع صور', 'Verified buyers': 'مشتريات موثّقات', '5 stars': '5 نجوم', '4 stars': '4 نجوم', 'Most recent': 'الأحدث',
    'With photos first': 'الصور أولاً', 'Highest rated': 'الأعلى تقييماً', 'Lowest rated': 'الأقل تقييماً', 'Oldest': 'الأقدم' };
  function localize(root) {
    if (LANG !== 'ar') return;
    root.querySelectorAll('.hsr-chip, .hsr-sort option').forEach(function (n) { var t = UI[n.textContent.trim()]; if (t) n.textContent = t; });
  }

  /* ── Shared pieces ── */
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  function who(r) {
    var name = (r.customer && r.customer.display_name) || T.customer;
    return '<div class="hsr-who"><span class="hsr-ava" aria-hidden="true">' + esc(initial(name)) + '</span><span class="hsr-who-t"><span class="hsr-name" dir="auto">' + esc(name) + '</span><span class="hsr-meta">' +
      (r.is_verified ? '<span class="hsr-ver">' + CHECK + T.verified + '</span>' : '') + '<span>' + ago(r.created_at) + '</span></span></span></div>';
  }
  function thumbs(r, media) {
    if (!(r.media || []).length) return '';
    return '<div class="hsr-media">' + r.media.map(function (m) {
      var i = media.findIndex(function (x) { return x.m === m; });
      return '<button type="button" data-lb="' + i + '"><img loading="lazy" src="' + esc(m.thumbnail_url || m.url) + '" alt="">' + (m.type === 'video' ? '<span class="hsr-play" aria-hidden="true"></span>' : '') + '</button>';
    }).join('') + '</div>';
  }
  function card(r, media, i, withProduct) {
    var body = r.body || '', long = body.length > 300;
    var p = withProduct && r.product && r.product.name ? r.product : null;
    return '<article class="hsr-card" style="--i:' + Math.min(i, 8) + '">' +
      '<div class="hsr-card-top">' + stars(r.rating) + '</div>' +
      (r.heading ? '<h3 class="hsr-h" dir="auto">' + esc(r.heading) + '</h3>' : '') +
      (body ? '<p class="hsr-body' + (long ? ' is-clamp' : '') + '" dir="auto">' + esc(body) + '</p>' + (long ? '<button type="button" class="hsr-link" data-expand>' + T.readMore + '</button>' : '') : '') +
      thumbs(r, media) + who(r) +
      (r.store_reply && r.store_reply.body ? '<div class="hsr-reply"><span class="hsr-reply-l">' + T.replied + '</span><p dir="auto">' + esc(r.store_reply.body) + '</p></div>' : '') +
      (p ? '<a class="hsr-prod"' + (p.handle ? ' href="/products/' + esc(p.handle) + '"' : '') + '>' + (p.image ? '<img loading="lazy" src="' + esc(p.image) + '" alt="">' : '') + '<span>' + esc(p.name) + '</span></a>' : '') +
      '</article>';
  }
  function mediaOf(list) { var out = []; list.forEach(function (r) { (r.media || []).forEach(function (m) { out.push({ m: m, r: r }); }); }); return out; }
  function loadAll(url) {
    var all = [], rating = null;
    function page(n) {
      return getJson(url + (url.indexOf('?') < 0 ? '?' : '&') + 'limit=100&page=' + n).then(function (j) {
        all = all.concat(j.data || []);
        rating = j.rating || rating;
        if (all.length < ((j.meta && j.meta.total_count) || 0) && (j.data || []).length && n < 6) return page(n + 1);
        return { items: all, rating: rating };
      });
    }
    return page(1);
  }
  function wire(root, state, render) {
    root.addEventListener('click', function (e) {
      var w = e.target.closest('[data-hsr-write]');
      if (w) { e.preventDefault(); return openWrite({ product: root.dataset.pid, api: root.dataset.api }); }
      var f = e.target.closest('[data-f]');
      if (f) { state.filter = state.filter === f.dataset.f && /^[1-5]$/.test(f.dataset.f) ? 'all' : f.dataset.f; state.shown = state.per; return render(); }
      if (e.target.closest('[data-more]')) { state.shown += state.per; return render(true); }
      var ex = e.target.closest('[data-expand]');
      if (ex) { ex.previousElementSibling.classList.remove('is-clamp'); return ex.remove(); }
      var b = e.target.closest('[data-lb]');
      if (b) openLb(state.media, Number(b.dataset.lb));
    });
  }
  function pick(state) {
    var f = state.filter;
    var list = state.all.filter(function (r) {
      if (f === 'photos') return r.media && r.media.length;
      if (f === 'verified') return r.is_verified;
      if (/^[1-5]$/.test(f)) return Math.round(r.rating) === Number(f);
      return true;
    });
    var t = function (r) { return new Date(r.created_at).getTime(); }, has = function (r) { return (r.media || []).length ? 1 : 0; };
    var by = { recent: function (a, b) { return t(b) - t(a); }, oldest: function (a, b) { return t(a) - t(b); },
      high: function (a, b) { return b.rating - a.rating || t(b) - t(a); }, low: function (a, b) { return a.rating - b.rating || t(b) - t(a); },
      photos: function (a, b) { return has(b) - has(a) || t(b) - t(a); } };
    return list.sort(by[state.sort] || by.recent);
  }

  /* ── Product page section ── */
  function initProduct(root) {
    if (root._hsr) return; root._hsr = true;
    localize(root);
    var q = function (s) { return root.querySelector(s); };
    var state = { all: [], media: [], filter: 'all', sort: 'recent', per: Number(root.dataset.per) || 9 };
    state.shown = state.per;
    var api = (root.dataset.api || APP).replace(/\/$/, '');

    function summary(rt) {
      q('[data-avg]').textContent = rt.count ? rt.average.toFixed(1) : '–';
      q('[data-avg-stars]').style.setProperty('--p', (rt.count ? rt.average / 5 * 100 : 0) + '%');
      q('[data-avg-sub]').textContent = rt.count ? T.based(rt.count) : T.none;
      var max = Math.max.apply(null, rt.counts.concat([1]));
      q('[data-bars]').innerHTML = [5, 4, 3, 2, 1].map(function (s) {
        var n = rt.counts[s - 1] || 0;
        return '<button type="button" class="hsr-bar" data-f="' + s + '"' + (n ? '' : ' disabled') + '><span>' + s + '</span><span class="hsr-bar-track"><span class="hsr-bar-fill" style="--w:' + (n / max) + '"></span></span><span class="hsr-bar-n">' + n + '</span></button>';
      }).join('');
      root.classList.toggle('is-empty', !rt.count);
    }
    function photos() {
      var wrap = q('[data-photos]'); if (!wrap) return;
      wrap.hidden = !state.media.length;
      if (!state.media.length) return;
      q('[data-photos-n]').textContent = T.photos(state.media.length);
      q('[data-photos-row]').innerHTML = state.media.map(function (x, i) {
        return '<button type="button" class="hsr-ph" data-lb="' + i + '"><img loading="lazy" src="' + esc(x.m.thumbnail_url || x.m.url) + '" alt="">' + (x.m.type === 'video' ? '<span class="hsr-play" aria-hidden="true"></span>' : '') + '</button>';
      }).join('');
    }
    function render(keep) {
      var list = pick(state), grid = q('[data-grid]'), from = keep ? grid.children.length : 0;
      q('[data-showing]').textContent = list.length > state.per ? T.showing(Math.min(state.shown, list.length), list.length) : '';
      root.querySelectorAll('[data-f]').forEach(function (c) { c.classList.toggle('is-on', c.dataset.f === state.filter); c.setAttribute('aria-pressed', c.dataset.f === state.filter); });
      q('[data-more]').hidden = list.length <= state.shown;
      if (!list.length) { grid.innerHTML = '<div class="hsr-empty"><p>' + (state.all.length ? T.noMatch : T.first) + '</p></div>'; return; }
      var html = list.slice(from, state.shown).map(function (r, i) { return card(r, state.media, i); }).join('');
      if (keep) grid.insertAdjacentHTML('beforeend', html); else grid.innerHTML = html;
    }
    wire(root, state, render);
    q('[data-sort]').addEventListener('change', function () { state.sort = this.value; state.shown = state.per; render(); });

    loadAll(api + '/reviews?product.id=' + encodeURIComponent(root.dataset.pid) + '&state=approved').then(function (res) {
      state.all = res.items; state.media = mediaOf(res.items);
      var rt = (res.items[0] && res.items[0].product && res.items[0].product.rating) || { average: 0, count: 0, counts: [0, 0, 0, 0, 0] };
      root.classList.add('is-ready');
      summary(rt); photos(); render();
    }).catch(function () {
      q('[data-grid]').innerHTML = '<div class="hsr-empty"><p>' + T.failed + '</p></div>';
    });
  }

  /* ── All-reviews wall (home carousel / reviews page grid) ── */
  function initWall(root) {
    if (root._hsr) return; root._hsr = true;
    localize(root);
    var q = function (s) { return root.querySelector(s); };
    var grid = root.dataset.layout === 'grid';
    var state = { all: [], media: [], filter: 'all', sort: 'recent', per: Number(root.dataset.per) || 12 };
    state.shown = state.per;
    var api = (root.dataset.api || APP).replace(/\/$/, '');
    function render(keep) {
      var list = pick(state), box = q('[data-grid]'), from = keep ? box.children.length : 0;
      root.querySelectorAll('[data-f]').forEach(function (c) { c.classList.toggle('is-on', c.dataset.f === state.filter); c.setAttribute('aria-pressed', c.dataset.f === state.filter); });
      var more = q('[data-more]'); if (more) more.hidden = !grid || list.length <= state.shown;
      if (!list.length) { box.innerHTML = '<div class="hsr-empty"><p>' + (state.all.length ? T.noMatch : T.none) + '</p></div>'; return; }
      var html = list.slice(from, state.shown).map(function (r, i) { return card(r, state.media, i, true); }).join('');
      if (keep) box.insertAdjacentHTML('beforeend', html); else box.innerHTML = html;
    }
    wire(root, state, render);
    root.querySelectorAll('[data-scroll]').forEach(function (b) {
      b.addEventListener('click', function () {
        var box = q('[data-grid]'), dir = Number(b.dataset.scroll) * (getComputedStyle(root).direction === 'rtl' ? -1 : 1);
        box.scrollBy({ left: dir * Math.max(300, box.clientWidth * .8), behavior: 'smooth' });
      });
    });
    var load = grid ? loadAll(api + '/wall') : getJson(api + '/wall?min=60&limit=' + state.per + (root.dataset.photos === '1' ? '&photos=1' : '')).then(function (j) { return { items: j.data || [], rating: j.rating }; });
    load.then(function (res) {
      state.all = res.items; state.media = mediaOf(res.items);
      var rt = res.rating || { average: 0, count: 0 };
      q('[data-avg]').textContent = rt.count ? rt.average.toFixed(1) : '–';
      q('[data-avg-stars]').style.setProperty('--p', (rt.count ? rt.average / 5 * 100 : 0) + '%');
      q('[data-avg-sub]').textContent = rt.count ? T.based(rt.count) : T.none;
      root.classList.add('is-ready');
      render();
    }).catch(function () { q('[data-grid]').innerHTML = '<div class="hsr-empty"><p>' + T.failed + '</p></div>'; });
  }

  function boot() {
    document.querySelectorAll('[data-hsr-product]').forEach(initProduct);
    document.querySelectorAll('[data-hsr-wall]').forEach(initWall);
  }
  window.HSReviews = { openWrite: openWrite, close: closeWrite, boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-hsr-open]');
    if (a) { e.preventDefault(); openWrite({ product: a.dataset.hsrOpen }); }
  });

  /* Review links from WhatsApp: /?hsreview=<product id>&o=<order>&k=<signature> (and the old ?fera=review&product=<id>) */
  var p = new URLSearchParams(location.search);
  var pid = p.get('hsreview') || (p.get('fera') === 'review' ? (p.get('product') || p.get('product_id') || 'store') : null);
  if (pid) openWrite({ product: /^\d+$/.test(pid) ? pid : '', o: p.get('o'), k: p.get('k'), stars: p.get('stars') });
})();
